import sedanImg from "../assets/sedan.jpg";
import suvImg from "../assets/suv.jpg";
import luxuryImg from "../assets/luxury.jpg";
import travellerImg from "../assets/traveller.jpg";
import busImg from "../assets/bus.jpg";

// Real, free-to-use destination photos (Wikimedia Commons).
// `card` = 500px thumbnail for cards; `large` = full-res for the hero.
const base = "https://upload.wikimedia.org/wikipedia/commons";

const make = (dir, file) => ({
  card: `${base}/thumb/${dir}/${file}/500px-${file}`,
  large: `${base}/${dir}/${file}`,
});

export const DEST_IMAGES = {
  bhopal: make("3/32", "Deewali_New_market.jpg"),
  ujjain: make("7/75", "Mahakaleshwar_Temple%2C_Ujjain.jpg"),
  maheshwar: make("3/39", "Maheshwar_fort.JPG"),
  pachmarhi: make("b/b4", "Pachmarhi_valley_Madhya_Pradesh_INDIA.jpg"),
  omkareshwar: make("0/01", "Omkareswar_Jyotirlinga.jpg"),
  indore: make("e/e1", "Indore_Rajwada01.jpg"),
};

// Vehicle photos: local assets, bundled at build time.
export const FLEET_IMAGES = {
  sedan: sedanImg,
  suv: suvImg,
  luxury: luxuryImg,
  tempo: travellerImg,
  bus: busImg,
};

// Hero background: local asset, bundled at build time so the hero never
// depends on an external host loading.
export { default as HERO_IMAGE } from "../assets/hero.jpg";
